import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleVisibilityNumbers } from '../../actions';

class VisibilityNumbers extends Component {
    render() {
        const { visibilityNumbers, toggleVisibilityNumbers } = this.props;
        return (
                <button className="btn btn-info" onClick={toggleVisibilityNumbers}>
                    {visibilityNumbers ? "N'afficher que les bornes" : "Afficher toutes les unités"}
                </button>
        );
    }
}

const mapStateToProps = ({ visibilityNumbers }) => ({ visibilityNumbers });

const mapDispatchToProps = dispatch =>
    bindActionCreators({ toggleVisibilityNumbers }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisibilityNumbers);
